import React from "react";
import { bindActionCreators } from "redux";
import { Row, Col, Modal, Select, Button, message } from "antd";
import PropTypes from "prop-types";
import CompanyLosService from "./services/company-los-services";
import { Table } from "components";
import { List, OrderedMap } from "immutable";
import { connect } from "react-redux";
import { CheckActionPermission } from "./checkPermissions";
import { fetchedCaseSellerList } from "./actions";
import { SCHEME_TYPE_ENUM } from "../../constants";
import { getSchemeFromBusinessProductType } from "../../components/helper";
import { BUSINESS_PRODUCT_TYPE_UPDATED } from "../../constants/enums";

class CompanyCasesAsSellerDisplay extends React.Component {

    state = {
        sellerData: null,
        loading: false,
        selectedRow: {},
        showEditModal: false,
        flexibleParamList: null,
        flexibleParaExisting:null,
        dwd_sp_id: null,
        dw_description: null,
        totalCount: 0,
        searchParam : "",
        showConfirmModal: false,
        updateLoading: false,
        show_api_err: false,
        non_field_error: null,
        schemeData: null,
        selectedSchemeId: null,
    }
    page = 1;
    pageSize = 10;
    
    componentDidMount() {
        this.setState({
            loading: true
        });
        this.getCasesSeller(null);
        CompanyLosService.getSchemeDetails(this.props.companyId).then(({data})=>{
            return(
                this.setState({schemeData:data})
            );}
        );
    }

    componentDidUpdate(){
        if(this.props.casesAsSellerStatus=="FETCHING" && !this.state.loading){
            this.setState({
                loading: true
            });
            this.page = 1;
            this.pageSize = 10;
            CompanyLosService.getCasesAsSeller(this.props.companyId, null, 1, 10).then(({ data }) => {
                this.props.fetchedCaseSellerList();
                this.setState({
                    sellerData: data.results,
                    loading: false,
                    totalCount: data.count
                });
            }).catch((err) => {
                this.setState({
                    loading: false
                });
                console.log("err", err);
            });
        }
    }

    getCasesSeller(searchParam, page = this.page, pageSize = this.pageSize) {
        this.setState({
            loading : true
        });
        this.page = page;
        this.pageSize = pageSize;
        CompanyLosService.getCasesAsSeller(this.props.companyId, searchParam, page, pageSize).then(({ data }) => {
            this.props.fetchedCaseSellerList();
            this.setState({
                sellerData: data.results,
                loading: false,
                totalCount: data.count
            });
        }).catch((err) => {
            this.setState({
                loading: false
            });
            console.log("err", err);
        });
    }
    
    onPageSizeChange = (page , pageSize) => {
        this.page = page;
        this.pageSize = pageSize;
        this.getCasesSeller(this.state.searchParam, page , pageSize);
    }

    getFlexibleParameters = (schemeId) => {
        CompanyLosService.getFlexibleParamValue(this.props.companyId, schemeId).then(({ data }) => {
            this.setState({
                flexibleParamList: data
            });
        }).catch((err) => {
            console.log("err", err);
        });
    }

    editSellerCase = (props, row) => {
        this.setState({
            selectedRow: row,
            showEditModal: true,
            flexibleParaExisting:row.flexible_parameter,
        });
        if(props){
            this.getFlexibleParameters(props);
        }
    }

    closeEditModal = () => {
        this.setState({
            showEditModal: false,
            selectedRow: {},
            dwd_sp_id: null,
            dw_description: null,
            showConfirmModal: false,
            show_api_err: false,
            non_field_error: null,
            selectedSchemeId: null
        });
    }

    onFilter = (value) => {
        this.setState({
            loading: true,
            searchParam: value?.search[0]
        } , () => {
            this.getCasesSeller(this.state.searchParam , this.page , this.pageSize);
        });
    }

    onChange = (val) => {
        this.setState({
            dwd_sp_id: val.id,
            dw_description: val.description
        });
    }
    onChangeSchemeId = (val) => {
        this.setState({
            selectedSchemeId:val,
            dw_description: null,
            flexibleParaExisting: null           
        });
        val && CompanyLosService.getFlexibleParamValue(this.props.companyId, val).then(({ data }) => {
            this.setState({
                flexibleParamList: data
            });
        }).catch((err) => {
            console.log("err", err);
        });
    }

    onSubmitEdit = () => {
        const submitData = {
            dwd_sp_id: this.state.dwd_sp_id,
            scheme_id: this.state.selectedSchemeId
        };
        this.setState({
            updateLoading: true
        });
        CompanyLosService.updateFlexibleParameter(this.props.companyId, this.state.selectedRow.id, submitData, this.state.selectedRow?.anchor?.id).then(({ data }) => {
            console.log("data", data);
            message.success("Parameters updated successfully!");
            this.setState({
                updateLoading: false
            });
            this.closeEditModal();
            this.getCasesSeller(this.state.searchParam, this.page , this.pageSize);
        }).catch((err) => {
            this.setState({
                updateLoading: false,
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors?.length && err?.non_field_errors || err[Object.keys(err)]?.length && err[Object.keys(err)][0] || "Please enter correct data",
            });
            console.log("err", err);
        });
    }

    getSelectedScheme = () => {
        return this.state.schemeData?.find(el=>el.id === (this.state.selectedSchemeId || this.state.selectedRow?.scheme_id));
    }
     formatBusinessProductType = (value) => {
            if (!value) return "--";

            const keyName = BUSINESS_PRODUCT_TYPE_UPDATED
                .keySeq()
                .find(k => BUSINESS_PRODUCT_TYPE_UPDATED.get(k) === value);

            return keyName
                ? keyName
                    .toLowerCase()
                    .split("_")
                    .map(w => w[0].toUpperCase() + w.slice(1))
                    .join(" ")
                : value;
        };
   

    render() {
        const sellerColumn = new OrderedMap({
            id: {
                title: "Case Id",
                dataIndex: "id",
                key: "id",
                align: "center",
                sorter: (a, b) => a.id - b.id,
            },
            name: {
                title: "Name",
                dataIndex: "name",
                key: "name",
                align: "center",
                sorter: (a, b) => {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                },
            },
            gstin: {
                title: "GSTIN",
                dataIndex: "gstin",
                key: "gstin",
                align: "center",
                sorter: (a, b) => {
                    if (a.gstin < b.gstin) { return -1; }
                    if (a.gstin > b.gstin) { return 1; }
                    return 0;
                },
            },
            status: {
                title: "Current Stage",
                dataIndex: "status",
                key: "status",
                align: "center",
            },
            lender: {
                title: "Lender",
                dataIndex: "bank.name",
                key: "bank.name",
                align: "center",
                sorter: (a, b) => {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                },
            },
            anchor: {
                title: "Anchor",
                dataIndex: "anchor.short_name",
                key: "anchor.short_name",
                align: "center",
                render: _ => _ ? _ : "--",
                // sorter: (a, b) => {
                //     if (a.short_name < b.short_name) { return -1; }
                //     if (a.short_name > b.short_name) { return 1; }
                //     return 0;
                // },
            },
            program_type: {
                title: "Program Type",
                dataIndex: "is_d2r_case",
                key: "is_d2r_case",
                align: "center",
                render: _ => _ ? 'D2R' : "--",
            },
            business_product_type: {
                title: "Business Product Type",
                dataIndex: "business_product_type",
                key: "business_product_type",
                align: "center",
               render: (value) => this.formatBusinessProductType(value),
            },
            scheme: {
                title: "Scheme",
                dataIndex: "scheme",
                key: "scheme",
                align: "center",
                width: 500
            },
            flexible_parameter: {
                title: "Flexible Parameter",
                dataIndex: "flexible_parameter",
                key: "flexible_parameter",
                align: "center"
            },
            last_updated_by: {
                title: "Last Updated By",
                dataIndex: "last_updated_by",
                key: "last_updated_by",
                align: "center",
            },
            id_edit: {
                title: "Action",
                dataIndex: "scheme_id",
                key: "scheme_id",
                align: "center",
                render: (props, row) => <CheckActionPermission component={<a onClick={() => this.editSellerCase(props, row)}>Edit</a>} permission={this.props.caseAsSellerPermission} />,
            },
        });
        const { selectedRow,loading} = this.state;
     
        return (
            <Row className={"p-10"}>
                
                <Modal visible={this.state.showEditModal} okText={"Submit"} footer={null} onCancel={() => this.closeEditModal()} width={600}>
                    <p>Case ID: <h3>{selectedRow?.id}</h3></p>
                    <p>Name: <h3>{selectedRow.name}</h3></p>
                    <p>GSTIN: <h3>{selectedRow.gstin}</h3></p>
                    <p>Current Stage: <h3>{selectedRow.status}</h3></p>
                    <p>Lender: <h3>{selectedRow.bank && selectedRow.bank?.name}</h3></p>
                    {selectedRow.anchor?.short_name && <p>Anchor: <h3>{selectedRow.anchor && selectedRow.anchor?.short_name}</h3></p>}
                    <p>Scheme: <h3>{selectedRow.scheme}</h3></p>
                    <p>Flexible Parameter: <h3>{selectedRow.flexible_parameter}</h3></p>
                    <p>Business Product Type :<h3>{this.formatBusinessProductType(selectedRow.business_product_type)}</h3></p>
                    <p>Last Updated By: <h3>{selectedRow.last_updated_by}</h3></p>
                    <hr />
                    {!this.state.showConfirmModal &&
                        <Row span={24}>
                            <Col span={24}>
                                <p>Scheme</p>
                            </Col>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    style={{ width: 400 }}
                                    placeholder="Select Scheme"
                                    onChange={(val) => this.onChangeSchemeId(val)}
                                    value={this.state.selectedSchemeId || selectedRow?.scheme_id}
                                    disabled={selectedRow?.is_above_progcap_credit}
                                >
                                    {this.state.schemeData && this.state.schemeData.filter(__ => getSchemeFromBusinessProductType(selectedRow.business_product_type).includes((__.scheme_type)))?.map(_=>_.id).map((item, k) => {
                                        return (
                                            <Select.Option value={item} key={k}>{item}</Select.Option>
                                        );
                                    })}
                                </Select>
                                {selectedRow?.is_above_progcap_credit && 
                                <Col span={24}>
                                    <h5>Case Task is above Progcap Credit</h5>
                                </Col>
                                }
                                {!selectedRow?.is_above_progcap_credit && 
                                <Col span={24}>
                                    <h5>{this.state.schemeData?.find(el=>el.id === this.state.selectedSchemeId)?.description}</h5>
                                </Col>
                                }
                            </Col>
                        </Row>}
                    {!this.state.showConfirmModal &&
                        <Row span={24}>
                            <Col span={24}>
                                <p>Flexible Parameter</p>
                            </Col>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    style={{ width: 400 }}
                                    placeholder="Select Flexible Parameter"
                                    onChange={(val) => this.onChange(val)}
                                    value={this.state.dw_description || this.state.flexibleParaExisting}
                                >
                                    {this.state.flexibleParamList && this.state.flexibleParamList.map((item, k) => {
                                        return (
                                            <Select.Option value={item} key={k}>{item.description}</Select.Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                            <Col span={24}>
                                <Button style={{ marginTop: "20px" }} onClick={() => this.setState({ showConfirmModal: true })} loading={this.state.loading} disabled={this.state.dwd_sp_id == null} className={"ant-btn ant-btn-primary"}>Submit</Button>
                            </Col>
                        </Row>}
                    {
                        this.state.showConfirmModal && <Row>
                            <div style={{color: "red", fontWeight: "bold"}}>This will update the parameters for Case ID - {selectedRow.id} from 
                                <div style={{display:"flex", flexDirection:"row", alignItems:"center",justifyContent:"center", padding:"10px"}}>
                                    {this.state.selectedSchemeId && 
                                    <div style={{display:"flex", flexDirection:"column",alignItems:"center"}}>
                                        <div style={{display:"flex", flexDirection:"row",justifyContent:"center", textAlign:"center", alignItems:"center"}}>
                                            <p style={{padding:"0 10px"}}>{selectedRow.scheme}</p>
                                            <p>to</p> 
                                            <p style={{padding:"0 10px"}}>{this.state.schemeData?.find(el=>el.id === this.state.selectedSchemeId)?.description}
                                            </p>
                                        </div>
                                        <div>
                                            <p>and</p>
                                        </div>
                                    </div>
                                    }
                                </div>
                                <p>{selectedRow.flexible_parameter} to {this.state.dw_description}.</p>
                            </div>
                            {SCHEME_TYPE_ENUM.get('PER_UNIT_SUBVENTION_SCHEME') == this.getSelectedScheme()?.scheme_type &&  <p style={{color: "red", fontWeight: "bold"}}>As per above parameters, price of {this.getSelectedScheme()?.unit.name || ''} can vary from {(((365*this.getSelectedScheme()?.dwd_sp_default.subvention_per_unit)/(this.getSelectedScheme()?.min_min_normal_roi * this.getSelectedScheme()?.dwd_sp_default.subvention_days))*100).toFixed(2)} to {(((365*this.getSelectedScheme()?.dwd_sp_default.subvention_per_unit)/(this.getSelectedScheme()?.min_normal_roi * this.getSelectedScheme()?.dwd_sp_default.subvention_days))*100).toFixed(2)}</p>}
                            <p style={{color: "red", fontWeight: "bold"}}>Are you sure?</p>
                            
                            <Col>
                                {
                                    this.state.show_api_err?<Col className={"m-5"}>
                                        <span className={"error-text"}>* {this.state.non_field_error}</span>
                                    </Col>:null
                                }
                                <Button style={{ marginTop: "20px" }} onClick={() => this.onSubmitEdit()} loading={this.state.updateLoading} className={"ant-btn ant-btn-primary"}>Yes</Button>
                                <Button style={{ marginTop: "20px", marginLeft: "20px" }} onClick={() => this.setState({showConfirmModal: false, show_api_err: false, non_field_error: null, selectedSchemeId: null})} className={"ant-btn ant-btn-primary"}>No</Button>
                            </Col>
                        </Row>
                    }
                </Modal>
                <Row>
                    <Col span={24} style={{ background: "#ffffff" }}>
                        <Table
                            data={List(this.state.sellerData)}
                            columns={sellerColumn}
                            showFilters
                            showTopSection
                            checkedColumns={[]}
                            size={"small"}
                            type={"inner"}
                            noRowSelection={true}
                            onFilter={this.onFilter}
                            showColumnSelector={false}
                            hideColumnFiltersModal
                            showPaginationOnly={false}
                            loading={loading}
                            showFooter={false}
                            pagination={{
                                current: this.page,
                                showSizeChanger: true,
                                defaultPageSize: this.pageSize,
                                pageSizeOptions: [
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                total: this.state.totalCount,
                                onChange: (page, pageSize) => this.getCasesSeller("", page, pageSize),
                                onShowSizeChange: this.onPageSizeChange
                            }} />
                    </Col>
                </Row>
            </Row>
        );
    }
}

CompanyCasesAsSellerDisplay.propTypes = {
    caseAsSellerPermission: PropTypes.bool,
    companyId: PropTypes.string,
    casesAsSellerStatus: PropTypes.string,
    fetchedCaseSellerList: PropTypes.func
};

const mapStateToProps = (state, props) => {
    const { match: { params } } = props;
    if (!params.companyId) {
        return {
            companyId: null
        };
    }
    return {
        caseAsSellerPermission: state.user.getIn(["permissions", "page_cases_as_seller_edit"], false),
        casesAsSellerStatus: state.companyLosProfiles.getIn(["casesAsSeller", "status"]),
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchedCaseSellerList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCasesAsSellerDisplay);